import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './styles/track-list.css';
import './styles/agent-mode.css';
import App from './App';
import UnicornSingleton from './UnicornSingleton.jsx';
import { AuthProvider } from './contexts/AuthContext';
import { AppModeProvider } from './contexts/AppModeContext';
import { MusicPlayerProvider } from './contexts/MusicPlayerContext';
import { PendingApprovalsProvider } from './contexts/PendingApprovalsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UnicornSingleton />
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <AppModeProvider>
          <PendingApprovalsProvider>
            <MusicPlayerProvider>
              <App />
            </MusicPlayerProvider>
          </PendingApprovalsProvider>
        </AppModeProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
); 